import type { Namespace, TFunction } from "i18next";

// Calls i18next's t() with a runtime-resolved key. Use only when the key
// is genuinely dynamic (e.g. a Zod error message stored as an i18n path).
// For literal keys, call t() directly to keep type-safety.
export function tDyn<N extends Namespace>(t: TFunction<N>, key: string | undefined): string | undefined {
  if (!key)
    return undefined;
  // @ts-expect-error caller asserts this is a valid translation path
  return t(key);
}
